import { FieldValidation } from '@brightmls/nextgen.lae.flc';
import { FieldMetadata } from '../contexts/MetadataContext';

export const isFieldHidden = (
  fieldValidation: FieldValidation,
  fieldMeta: FieldMetadata | undefined,
): boolean => {
  return fieldValidation.isHidden || false;
};

export const convertFieldValue = (
  value: any,
  fieldMeta?: FieldMetadata,
): any => {
  if (typeof value === 'undefined' || value === null || Array.isArray(value)) {
    return value;
  }
  if (!fieldMeta) return String(value);

  switch (fieldMeta.Type) {
    case 'Edm.Int64':
    case 'Edm.Int32':
    case 'Edm.Int16':
    case 'Edm.Double':
    case 'Edm.Byte':
      // value.includes('.0') prevents .0 from being overwritten as a user is typing
      // returning a number type drops the .0 because it is not significant
      // we'll use a string to preserve it so the user can type 1000.05, for example
      if (isNaN(value) || (typeof value === 'string' && value.includes('.0'))) {
        return String(value);
      }
      if (value === '') {
        return null;
      }

      if (
        typeof value === 'string' &&
        value.endsWith('.') &&
        typeof fieldMeta?.Definition?.Scale === 'number' &&
        fieldMeta.Definition.Scale > 0
      ) {
        // we are mid-write of a decimal field -- allow this
        // aka "999." then typing 999.9
        return String(value);
      }

      return Number(value);
    case 'Edm.Boolean':
      if (value === 1 || value === '1') {
        value = true;
      } else if (value === 0 || value === '0') {
        value = false;
      }
      if (value === true || value === false) {
        return Boolean(value);
      }
      return value;
    default:
      return String(value);
  }
};
